import { useRef, useState } from 'react';
import { MB, MIME_TYPES_MAP } from '../../../utils/Constants';

export const useDraggableInputFile = (
  setValue,
  fileTypes,
  maxFileSize,
  inputSize
) => {
  const [showFileNameArea, setShowFileNameArea] = useState(false);
  const [touched, setTouched] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [fileData, setFileData] = useState({ name: '', size: 0 });

  const inputFileRef = useRef(null);

  const errorMessages = {
    INVALID_FILE_SIZE: {
      ['md']:
        'El archivo supera el peso máximo. Por favor, volvé a intentarlo.',
      ['sm']: (
        <>
          El archivo supera el peso máximo.
          <br />
          Por favor, volvé a intentarlo.
        </>
      ),
    },
    INVALID_FILE_TYPE: {
      ['md']: 'Tipo de archivo no soportado. Por favor, volvé a intentarlo.',
      ['sm']: (
        <>
          Tipo de archivo no soportado.
          <br />
          Por favor, volvé a intentarlo.
        </>
      ),
    },
  };

  const supportedTypes = fileTypes.map((type) => MIME_TYPES_MAP[type]);

  const getFileSizeInMB = (fileSize) => (fileSize / MB).toFixed(2);

  const handleFile = (file) => {
    setValue(file);
    setFileData({
      name: file.name,
      size: getFileSizeInMB(file.size),
    });
    setShowFileNameArea(true);
  };

  const showError = () => {
    setValue(null);
    setFileData({});
    setShowFileNameArea(false);
    setShowErrorMessage(true);
  };

  const deleteAttachedFile = () => {
    setValue(null);
    setFileData({});
    setShowFileNameArea(false);
    setShowErrorMessage(false);
    setErrorMessage(null);
  };

  const validFileType = (file) => {
    if (supportedTypes.includes(file?.type)) {
      return true;
    } else {
      setErrorMessage(errorMessages.INVALID_FILE_TYPE[inputSize]);
      return false;
    }
  };

  const validFileSize = (file) => {
    if (getFileSizeInMB(file.size) <= maxFileSize) {
      return true;
    } else {
      setErrorMessage(errorMessages.INVALID_FILE_SIZE[inputSize]);
      return false;
    }
  };

  const removeDragData = (ev) => {
    ev.dataTransfer.items?.clear();
    ev.dataTransfer.clearData();
  };

  const removeInputFileData = () => {
    inputFileRef.current.value = '';
  };

  const dragOverHandler = (ev) => {
    ev.preventDefault();
  };

  const dropHandler = (ev) => {
    ev.preventDefault();
    setTouched(true);
    [...ev.dataTransfer.items].map((dataTransferItem) => {
      if (dataTransferItem.kind === 'file') {
        const file = dataTransferItem.getAsFile();
        if (validFileType(file) && validFileSize(file)) {
          handleFile(file);
        } else {
          showError();
        }
      }
    });

    removeDragData(ev);
  };

  const handleInputFileClick = (ev) => {
    ev.preventDefault();
    setTouched(true);
    const file = inputFileRef.current.files[0];
    if (validFileType(file) && validFileSize(file)) {
      handleFile(file);
    } else {
      showError();
    }
    removeInputFileData();
  };

  const handleDeleteClick = () => {
    deleteAttachedFile();
  };

  return [
    touched,
    inputFileRef,
    showFileNameArea,
    fileData,
    dragOverHandler,
    dropHandler,
    handleInputFileClick,
    handleDeleteClick,
    showErrorMessage,
    errorMessage,
  ];
};
